const REFERRAL_ID_STORAGE_KEY = 'refMyAcuvueId';

export const getRefMyAcuvueId = (): string | null =>
  localStorage.getItem(REFERRAL_ID_STORAGE_KEY);

export const setRefMyAcuvueId = (id: string): void =>
  localStorage.setItem(REFERRAL_ID_STORAGE_KEY, id);

export const removeRefMyAcuvueId = (): void =>
  localStorage.removeItem(REFERRAL_ID_STORAGE_KEY);

export const refIdFromParams = (): string | null => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get('refMyAcuvueId');
};
